import 'react-app-polyfill/ie11'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Route } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'
import { store, history } from './redux/store'
import { unregister } from './registerServiceWorker'
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'
import AppContainer from './components/app/AppContainer'
// import withTracker from './libs/google-analytics'
import Raven from 'raven-js'
import './libs/polyfills'
import settings from './libs/settings'
import './index.css'
import { initWebComponents } from './libs/WebComponent'

if (settings.isProduction) {
  Raven
    .config('https://7f30766d2a1843999afc72ce358a8d38@sentry.io/1318105')
    .install()

  window.addEventListener('unhandledrejection', (err) => {
    Raven.captureException(err)
  })
}

const theme = createTheme({
  status: {
    text: '#0538a0'
  },
  palette: {
    primary: {
      light: '#4d638e',
      main: '#213D72',
      dark: '#1a305b'
    },
    secondary: {
      light: '#4d90df',
      main: '#2075d7',
      dark: '#1a5dac'
    }
  },
  typography: {
    fontFamily: '\'Arial\', sans-serif',
    body1: {
      color: 'rgba(0, 0, 0, 1.0)'
    }
  },
  overrides: {
    MuiTableCell: {
      paddingDense: {
        paddingLeft: 6,
        paddingRight: 6,
        '&:last-child': {
          paddingRight: 6
        }
      }
    },
    MuiButton: {
      sizeSmall: {
        fontSize: '0.8rem'
      }
    }
  }
})

unregister()
if (typeof window !== "undefined") {
  /* eslint-disable */
  // @ts-ignore
  window.heapReadyCb = window.heapReadyCb || [], window.heap = window.heap || [], heap.load = function (e, t) { window.heap.envId = e, window.heap.clientConfig = t = t || {}, window.heap.clientConfig.shouldFetchServerConfig = !1; var a = document.createElement("script"); a.type = "text/javascript", a.async = !0, a.src = "https://hput.ipdanalytics.com/config/" + e + "/heap_config.js"; var r = document.getElementsByTagName("script")[0]; r.parentNode.insertBefore(a, r); var n = ["init", "startTracking", "stopTracking", "track", "resetIdentity", "identify", "identifyHashed", "getSessionId", "getUserId", "getIdentity", "addUserProperties", "addEventProperties", "removeEventProperty", "clearEventProperties", "addAccountProperties", "addAdapter", "addTransformer", "addTransformerFn", "onReady", "addPageviewProperties", "removePageviewProperty", "clearPageviewProperties", "trackPageview"], i = function (e) { return function () { var t = Array.prototype.slice.call(arguments, 0); window.heapReadyCb.push({ name: e, fn: function () { heap[e] && heap[e].apply(heap, t) } }) } }; for (var p = 0; p < n.length; p++)heap[n[p]] = i(n[p]) };
  // @ts-ignore
  window.heap.load(
    { production: "617331428", dev: "3037290085" }[settings.APP_ENV || ""],
    {
      ingestServer: "https://hput.ipdanalytics.com",
      sdk: {
        domain: 'https://hput.ipdanalytics.com',
      }
    }
  );
  /* eslint-enable */
}
if (document.getElementById('root')) {
  ReactDOM.render(
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Route path='/' component={AppContainer} />
        </ConnectedRouter>
      </Provider>
    </MuiThemeProvider>,
    document.getElementById('root')
  )
} else {
  initWebComponents(theme)
}
